import { withInstall } from '@tav-ui/utils/with-install'
import ButtonGroup from './src/button-group.vue'
const TaButtonGroup = withInstall(ButtonGroup)
export { TaButtonGroup }
export default TaButtonGroup
export * from './src/types'
